var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 199.715 84.242",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#627eea;}.a,.f{stroke:#404040;stroke-width:3px;}.b{fill:#c5c6dd;}.c,.f{fill:#fff;}.d{fill:#939dc3;}.e{fill:#ccd1d9;}.g{fill:gray;font-size:17px;font-family:Montserrat-SemiBold, Montserrat;font-weight:600;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1157.1 -321.563)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1158.6 351.55)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 26.377,
    cy: 26.377,
    rx: 26.377,
    ry: 26.377
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.837 6.594)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.5,0V14.623l12.359,5.523Z",
    transform: "translate(4.863)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M12.361,0,0,20.145l12.361-5.523Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.5,20.791v9.936l12.368-17.11Z",
    transform: "translate(4.863 8.831)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M12.361,30.726V20.789L0,13.616Z",
    transform: "translate(0 8.831)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M7.5,21.568l12.359-7.176L7.5,8.872Z",
    transform: "translate(4.863 5.754)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M0,14.391l12.361,7.176V8.872Z",
    transform: "translate(0 5.754)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9 12)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M7.117,46.186q-.126.1-.258.2l-1.374,1.04S6.1,46.959,7.117,46.186Zm.8-12.7H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0H133.815a5,5,0,0,1,5,5V28.483a5,5,0,0,1-5,5H23.858c-4.215,3.2-13.083,9.926-16.741,12.7C12.179,42.11,9.8,36.487,7.914,33.483Z",
    transform: "translate(1225.5 311.063)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "g",
    transform: "translate(1236 333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Experience..."))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.23127bf4523cb6a967a8c7adaf5ee27d.svg";
export { ForwardRef as ReactComponent };